import { Job } from '../../Items/Job';
import * as actionType from '../action';

export interface JobState {
    jobs: Job[];
}

const initialState: JobState = {
    jobs: [],
};

const JobReducer = (
    state: JobState = initialState,
    action: any
): JobState => {
    switch (action.type) {
        case actionType.GET_JOBS:
            return { ...state, jobs: action.payload ?? [] };

        case actionType.ADD_JOB:
            return { ...state, jobs: [...state.jobs, action.payload] };

        case actionType.EDIT_JOB:
            return {
                ...state,
                jobs: state.jobs.map(job =>
                    job.id === action.payload.id ? action.payload : job
                ),
            };

        case actionType.DELETE_JOB:
            return {
                ...state,
                jobs: state.jobs.filter(job => job.id !== action.payload),
            };

        default:
            return state; // מספיק להחזיר state במקום {...state}
    }
};

export default JobReducer;
